module.exports = __webpack_public_path__ + "img/mastercard.5851c0d.svg";